<template>
  <el-dialog
    title="明源自定义字段配置"
    v-model="visible"
    width="800"
    :close-on-click-modal="false"
    :destroy-on-close="true"
  >
    <el-table :data="custom_fields" border stripe v-loading="loading">
      <el-table-column
        label="字段名称"
        prop="field_name"
        width="200"
      ></el-table-column>
      <el-table-column
        label="字段属性"
        prop="field"
        width="200"
      ></el-table-column>
      <el-table-column label="对应本地报备字段" min-width="200">
        <template #default="{ row }">
          <el-select v-model="row.local_field" placeholder="" clearable>
            <el-option label="公司名称" value="company"></el-option>
            <el-option label="到案人数" value="duenum"></el-option>
            <el-option label="到案时间" value="duetime"></el-option>
            <el-option label="带看人姓名" value="daikanname"></el-option>
            <el-option label="带看人电话" value="daikanmobile"></el-option>
            <el-option label="客户描述" value="remarks"></el-option>
          </el-select>
        </template>
      </el-table-column>
    </el-table>

    <template #footer>
      <el-button type="primary" :loading="saving" @click="onSubmit"
        >确定</el-button
      >
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      saving: false,
      loading: false,
      custom_fields: [],
    };
  },
  props: ["item"],
  emits: ["success"],
  watch: {
    item: {
      handler() {
        if (this.item) {
          this.visible = true;
          this.loadCustomField();
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * 加载自定义字段
     */
    loadCustomField() {
      if (this.item) {
        this.loading = true;
        this.$http
          .get(
            "admin/v1/estate/yunke/custom_field?id=" +
              this.item.id +
              "&project_id=" +
              this.item.yunkeProjId
          )
          .then((res) => {
            if (res.code == 0) {
              this.custom_fields = res.data;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    /**
     * 提交
     */
    onSubmit() {
      var fields = [];
      this.custom_fields.forEach((item) => {
        if (item.local_field) {
          fields.push({
            field_name: item.field_name,
            field: item.field,
            local_field: item.local_field,
            default_value: item.default_value,
            EstateId: this.item.id,
            field_belong: item.field_belong,
            field_type: item.field_type,
            is_required: item.is_required,
            project_id: item.project_id,
          });
        }
      });

      this.saving = true;
      this.$http
        .post("admin/v1/estate/set_custom_field?id=" + this.item.id, fields)
        .then((res) => {
          if (res.code == 0) {
            this.visible = false;
            this.$message.success(res.msg);
          } else {
            this.$message.danger(res.msg);
          }
        })
        .finally(() => (this.saving = false));
    },
  },
};
</script>

<style scoped></style>
